/**
 * EditProfileScreen.js – PWA (Exact UI Match)
 */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../services/authApi";

function EditProfileScreen() {
  const navigate = useNavigate();

  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    loadProfile();
  }, []);

  async function loadProfile() {
    try {
      const profile = await authAPI.getProfile();
      setFormData({
        name: profile?.name || "",
        email: profile?.email || "",
        phone: profile?.phone || "",
      });
      if (profile?.profilePicture) setImagePreview(profile.profilePicture);
    } catch {}
  }

  function handleImageChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  }

  async function handleSave() {
    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    if (imageFile) data.append("image", imageFile);

    await authAPI.updateProfile(data);
    setShowSuccess(true);
  }

  return (
    <>
      {/* 🔥 STYLES */}
      <style>{`
        body {
          margin: 0;
          background: radial-gradient(circle at top, #1e2a4a, #040812);
          font-family: 'Poppins', sans-serif;
          color: #fff;
        }
        .screen {
          min-height: 100vh;
          padding: 20px;
        }
        .header {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          padding: 10px 0 20px;
          border-bottom: 1px solid rgba(255,255,255,0.1);
        }
        .back {
          position: absolute;
          left: 0;
          font-size: 22px;
          cursor: pointer;
        }
        .title {
          font-size: 22px;
          font-weight: 600;
          color: #6aa7ff;
        }
        .avatar-wrap {
          display: flex;
          justify-content: center;
          margin: 30px 0;
          position: relative;
        }
        .avatar {
          width: 140px;
          height: 140px;
          border-radius: 50%;
          border: 4px solid #6aa7ff;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .camera {
          position: absolute;
          bottom: 10px;
          right: calc(50% - 70px);
          background: #6aa7ff;
          width: 38px;
          height: 38px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: white;
          font-size: 16px;
        }
        .label {
          margin: 16px 0 6px;
          font-weight: 500;
        }
        .input-box {
          background: #fff;
          border-radius: 14px;
          padding: 14px;
          display: flex;
          align-items: center;
          color: #000;
        }
        .input-box span {
          margin-right: 10px;
          opacity: 0.6;
        }
        .input-box input {
          border: none;
          outline: none;
          width: 100%;
          font-size: 15px;
        }
        .save-btn {
          margin-top: 40px;
          width: 100%;
          padding: 16px;
          background: #4f8fe8;
          border-radius: 16px;
          border: none;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
        }
        .overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
        }
        .alert {
          background: #fff;
          color: #000;
          padding: 24px;
          border-radius: 14px;
          width: 80%;
          max-width: 300px;
          text-align: center;
        }
        .alert button {
          margin-top: 16px;
          width: 100%;
          padding: 10px;
          border-radius: 10px;
          border: none;
          background: #4f8fe8;
          color: white;
          font-weight: 600;
        }
      `}</style>

      <div className="screen">
        {/* HEADER */}
        <div className="header">
          <div className="back" onClick={() => navigate(-1)}>←</div>
          <div className="title">Edit Profile</div>
        </div>

        {/* AVATAR */}
        <div className="avatar-wrap">
          <div className="avatar">
            {imagePreview ? <img src={imagePreview} alt="" /> : "👤"}
          </div>
          <label className="camera">
            📷
            <input type="file" hidden accept="image/*" onChange={handleImageChange} />
          </label>
        </div>

        {/* FORM */}
        <div className="label">Full Name</div>
        <div className="input-box">
          <span>👤</span>
          <input
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
        </div>

        <div className="label">Email Address</div>
        <div className="input-box">
          <span>✉️</span>
          <input
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
        </div>

        <div className="label">Phone Number</div>
        <div className="input-box">
          <span>📞</span>
          <input
            value={formData.phone}
            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          />
        </div>

        <button className="save-btn" onClick={handleSave}>
          ✔ Save Changes
        </button>
      </div>

      {/* SUCCESS ALERT */}
      {showSuccess && (
        <div className="overlay">
          <div className="alert">
            <h3>Profile Updated</h3>
            <p>Your profile has been updated successfully.</p>
            <button onClick={() => navigate(-1)}>OK</button>
          </div>
        </div>
      )}
    </>
  );
}

export default EditProfileScreen;
